var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.333 369.403L227.556 483.181H455.111C486.4 483.181 512 457.581 512 426.292C512 395.003 486.4 369.403 455.111 369.403H341.333ZM257.707 118.807L8.24889 368.265C3.12889 373.385 0 380.781 0 388.176V454.736C0 470.381 12.8 483.181 28.4444 483.181H95.0044C102.684 483.181 109.796 480.052 115.2 474.932L364.658 225.474L257.707 118.807ZM446.862 142.985C449.499 140.354 451.591 137.228 453.018 133.787C454.446 130.346 455.181 126.657 455.181 122.932C455.181 119.206 454.446 115.518 453.018 112.077C451.591 108.636 449.499 105.51 446.862 102.878L380.302 36.3184C377.671 33.6815 374.545 31.5895 371.104 30.1621C367.663 28.7347 363.974 28 360.249 28C356.524 28 352.835 28.7347 349.394 30.1621C345.953 31.5895 342.827 33.6815 340.196 36.3184L288.142 88.3717L394.809 195.038L446.862 142.985Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.fdbd5ef4bcc99fa7ddad67707782c766.svg";
export { ForwardRef as ReactComponent };